import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Redirect from 'components/Redirect';
import withUser from 'components/withUser';
import homepageReplacementPath from 'util/redirects';
import { compose } from 'redux';

import { analyticsEvents, track } from 'util/analytics';
import TrustPilot from 'components/TrustPilot-static';
import MarketingBanner from 'components/MarketingBanner';

import styles from './style.module.scss';
import WelcomeSection from './WelcomeSection';
import ValuePropSection from './ValuePropSection';
import TestimonialSection from './TestimonialSection';
import NotYourOrdinaryBrokerSection from './NotYourOrdinaryBrokerSection';
import BetterCompanyCultureSection from './BetterCompanyCultureSection';

class HomePage extends Component {
  static propTypes = {
    currentUser: PropTypes.any,
  };

  static defaultProps = {
    currentUser: undefined,
  };

  componentDidMount() {
    track(analyticsEvents.home_view, { nonInteraction: 1 });
  }

  render() {
    return (
      <div className={styles.container}>
        {homepageReplacementPath(this.props.currentUser) && (
          <Redirect to={homepageReplacementPath(this.props.currentUser)} />
        )}
        <Helmet title="Commercial Real Estate and Office Space">
          <meta name="og:title" content="The new way to find office space." />
          <meta name="og:type" content="website" />
          <meta name="og:url" content="https://www.squarefoot.com" />
          <meta name="og:image" content={require('./assets/New.png')} />
          <meta
            property="og:image:secure_url"
            content={require('./assets/New.png')}
          />
          {/* For thesquarefoot.com domain */}
          <meta
            name="google-site-verification"
            content="2LId-WsdFuRs-80dfmDcBYDtMHb3cCLO0F1muyoG5G8"
          />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            name="facebook-domain-verification"
            content="8yp9ictcse7zjdvs32mn4op7yf3t7a"
          />
        </Helmet>
        <MarketingBanner />
        <WelcomeSection />
        <TrustPilot />
        <ValuePropSection />
        <TestimonialSection />
        <NotYourOrdinaryBrokerSection />
        <BetterCompanyCultureSection />
      </div>
    );
  }
}

export default compose(
  connect((state) => ({
    searchCityName: state.search.cityName,
    searchNumEmployees: state.search.numEmployees,
  })),
  withUser
)(HomePage);
